export const APP_NAME = ' Client Portal';
export const COMPANY_NAME = 'M&M International';

export const ROLES = {
  SEARCH_ONLY: 'Search Only',
  CUSTOMER_USER: 'Customer User',
  CUSTOMER_ADMIN: 'Customer Admin',
  MM_ADMIN: 'M&M Admin',
  SYSTEM_ADMIN: 'System Admin',
};

export const SEARCH_KEYS = {
  SERIAL_NUMBER: 'serial-number',
  PART_NUMBER: 'part-number',
  PO_NUMBER: 'po-number',
};

export const SEARCH_HEADERS = {
  SERIAL_NUMBER: 'Serial Number',
  PART_NUMBER: 'Part Number',
  PO_NUMBER: 'P.O. Number',
};

export const SEARCH_KEY_HEADERS = {
  [SEARCH_KEYS.SERIAL_NUMBER]: 'Serial Number',
  [SEARCH_KEYS.PART_NUMBER]: 'Part Number',
  [SEARCH_KEYS.PO_NUMBER]: 'P.O. Number',
};

export const RoleList = Object.keys(ROLES).map(x => ROLES[x]);
